import MediaGroup from './component'
export default MediaGroup
